module.exports = __webpack_public_path__ + "static/vmware_7.6fb0cf86.jpg";